import {
  Button,
  Card,
  Dropdown,
  FormControl,
  Modal,
  OverlayTrigger,
  Popover,
  Tooltip,
} from "react-bootstrap";
import Avatar from "../../jsx/components/fields/avatar";
import profileAv from "../../icons/photos/profileAvatar.png";
import filter from "../../icons/photos/filter.svg";
import InputField from "../../jsx/components/fields/inputField";
import SearchAddressInput from "../../jsx/components/fields/searchAddressInput";
import PrimaryButton from "../../jsx/components/button/primaryButton";
import InternationalPhoneFormatFun from "../../ui/InternationalPhoneFormatFun";
import {
  emailValidation,
  firstNameValidation,
  minLengthValidation,
  noSpaceOnChange,
  numberValidation,
  phoneOnChange,
  phoneValidation,
} from "../../functions/validations";
import ResponceToaster from "../../jsx/components/responceToaster/responceToaster";

import { userById } from "../../service/api/user/userById";
import updateUserApi from "../../service/api/user/updateUserDetails";
// import { setUserDetails } from '../../feature/userDetails/userDetailsSlice'
import { resetState, setAccountDetailsModalTriggerRedux, setUserDetails } from "../../feature/userData/userData";
import { signout } from "../../feature/authSlice";
import deleteUser from "../../service/api/user/deleteUserById";
import { searchAddress } from "../../service/api/user/searchAddress";
import { addressByPlaceId } from "../../service/api/user/addressByPlaceID";

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useRef } from "react";
import WhiteGreenButton from "../../jsx/components/button/whiteGreenButton";
import ResponceForAPI from "../../component/backDrop/responcesForAPI";
import Select from "react-select";
import {
  btnBio,
  btnSubmit,
  btnUpdateProfile,
  btnUpdateProfileLoading,
} from "../../dataBaseFile/alert";
import {
  btnVerify,
  lblAddress,
  lblEmail,
  lblFirstName,
  lblLastName,
  lblOr,
  lblPhoneNumber,
  txtDeleteAccounConfirmation,
  txtMainInfo,
  txtMobileNumber,
  txtPhoneNumber,
  txtSearchAddress,
} from "../../dataBaseFile/label";
import {
  validEmailText,
  validFirstName,
  validLastName,
  validMobileNumberText,
} from "../../dataBaseFile/error";
import UpdateEmailPhoneInputField from "../../jsx/components/fields/updateEmailPhoneInputField";
import PhonenumberField from "../../jsx/components/fields/phoneFields";
import { resendCode } from "../../service/api/user/resendActivationCode";
import { activateUser } from "../../service/api/user/activationCode";
import { IoChevronDown, IoInformationCircleOutline } from "react-icons/io5";
import { switchRoleApi } from "../../service/api/user/switchRole";
import AcceptRejectModal from "../../jsx/components/modalAcceptReject/modalAcceptreject";
import EmailPhoneCombine from "../../jsx/components/fields/emailPhoneField";
import SkipButton from "../../jsx/components/button/skipButton";
import ChangePassword from "../changePassword/changePassword";
import UserAddOwnCompany from "../companies/userAddOwnCompany";
import { joinCompanyApi } from "../../service/api/companies/joinCompany";
import SearchableSelectAddress from "../../jsx/components/fields/searchableSelectAddress";
import { MdContentCopy, MdInfo } from "react-icons/md";
import { IoIosShareAlt } from "react-icons/io";
import SendProCodeInviteLink from "../../component/sendProCodeInviteLink/sendProCodeInviteLink";
const Bio = ({
  profileData,
  // editProfileTrigger = false,
  // setEditProfileTrigger,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { role, impersonateFlag, profilePicture, permissionArr, inProgressServiceCount, accountDetailsModalTriggerRedux } = useSelector((state) => state.user);

  const permissionArray = permissionArr[0] || []

  const [basicModalDeleteAccount, setBasicModalDeleteAccount] = useState(false);

  const [associatedCompanyName, setAssociatedCompanyName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [bioText, setBioText] = useState("");
  const [userName, setUserName] = useState("");
  const [phonenumber, setPhonenumber] = useState("");
  const [photoToUpload, setPhotoToUpload] = useState(null);
  const [countryCode, setCountryCode] = useState("");
  const [email, setEmail] = useState("");
  const [isFirstNameError, setIsFirstNameError] = useState(false);
  const [isEmailError, setIsEmailError] = useState(false);
  const [loaderActive, setLoaderActive] = useState(true);
  const [isErrorButton, setIsErrorButton] = useState(false);
  const [isSuccessButton, setIsSuccessButton] = useState(false);
  const [avatarUrl, setAvatarUrl] = useState("");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [avatarArr, setAvatarArr] = useState([]);
  const [avatarId, setAvatarId] = useState();
  const [updateBtn, setUpdateBtn] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const [addressArr, setAddressArr] = useState([]);
  const [searchText, setSearchText] = useState("");

  const [alias, setAlias] = useState("");

  const [roleName, setRoleName] = useState("");

  const [addressLine1, setAddressLine1] = useState(" ");
  const [addressLine2, setAddressLine2] = useState(" ");
  const [cityName, setCityName] = useState("");
  const [stateName, setStateName] = useState("");
  const [countryName, setCountryName] = useState(" ");
  const [zipCode, setZipCode] = useState("");

  const [latVal, setLatVal] = useState(0);
  const [longVal, setLongVal] = useState(0);
  const [address, setAddress] = useState("");
  const [placeIdVal, setPlaceId] = useState("");

  const [countryCodeNew, setCountryCodeNew] = useState();

  const [phoneNumberFormat, setPhoneNumberFormat] = useState();
  const [responceMsg, setResponceMsg] = useState("");
  const [updateProfileLoading, setUpdateProfileLoading] = useState(false);
  const [toasterType, setToasterType] = useState();
  const [handleToaster, setHandleToaster] = useState(false);

  const [apiResponse, setApiResponse] = useState(true);

  const [isEmailConfirmed, setIsEmailConfirmed] = useState(0);
  const [isPhoneConfirmed, setIsPhoneConfirmed] = useState(0);

  const [triggerForVerifyModal, setTriggerForVerifyModal] = useState(false);
  const [checkForEmailVerification, setCheckForEmailVerification] =
    useState(false);
  const [checkForPhoneVerification, setCheckForPhoneVerification] =
    useState(false);

  const [emailNew, setEmailNew] = useState("");
  const [phoneNumberNew, setPhoneNumberNew] = useState('');
  const [countryCodeNewNew, setCountryCodeNewNew] = useState(1);

  const [isEmailErrorNew, setIsEmailErrorNew] = useState(false);
  const [errorEmailMsg, setErrorEmailMsg] = useState("");
  const [isPhoneErrorNew, setIsPhoneErrorNew] = useState(false);

  const [checkAfterVerificationCodeSend, setCheckAfterVerificationCodeSend] =
    useState(false);

  const [recievedCodeValue, setRecievedCodeValue] = useState("");
  const [isCodeError, setIsCodeError] = useState(false);

  const [resendCodeTimer, setResendCodeTimer] = useState(60);
  const [resendCodeCheck, setResendCodeCheck] = useState(false);

  const [verifyUserLoading, setVerifyUserLoading] = useState(false);

  const [isVerificationCodeSendDirectly, setIsVerificationCodeSendDirectly] =
    useState(false);

  const intervalId = useRef(null);
  const [roleArr, setRoleArr] = useState([]);
  const [changeRoleModal, setChangeRoleModal] = useState(false)
  const [changedRoleId, setChangedRoleId] = useState()
  const [roleIHave, setRoleIHave] = useState([]);
  const [companyId, setCompanyId] = useState();

  const [joinCompanyModalTrigger, setJoinCompanyModalTrigger] = useState(false);
  const [joinCompanyCode, setJoinCompanyCode] = useState('');
  const [isJoinCompanyCodeError, setIsJoinCompanyCodeError] = useState(false);
  const [joinCompanyLoading, setJoinCompanyLoading] = useState(false);

  const [accountDetailsModalTrigger, setAccountDetailsModalTrigger] = useState(accountDetailsModalTriggerRedux);

  const [proCodeDetails, setProCodeDetails] = useState({});

  // Modal triggers for the Invite Friend
  const [sendProCodeModalTrigger, setSendProCodeModalTrigger] = useState(false);

  const handleCloseSendProCodeModal = () => setSendProCodeModalTrigger(false);
  const handleOpenProCodeModal = () => setSendProCodeModalTrigger(true);

  useEffect(() => {
    if (accountDetailsModalTrigger) {
      dispatch(setAccountDetailsModalTriggerRedux(true));
    } else if (!accountDetailsModalTrigger) {
      dispatch(setAccountDetailsModalTriggerRedux(false));
    }
  }, [accountDetailsModalTrigger])

  useEffect(() => {
    if (accountDetailsModalTriggerRedux) {
      setAccountDetailsModalTrigger(true)
    }
  }, [accountDetailsModalTriggerRedux])

  // useEffect(() => {
  //   setAccountDetailsModalTrigger(editProfileTrigger)
  // }, [editProfileTrigger])

  // useEffect(() => {
  //   if (!accountDetailsModalTrigger) {
  //     setEditProfileTrigger(false)
  //   }
  // }, [accountDetailsModalTrigger])

  const joinInfo = (
    <Tooltip id="tooltip">
      {" "}
      <strong>{`Please close your active service requests first, and then you will be able to join the company.`}</strong>
    </Tooltip>
  );

  const handleAlias = (e) => {
    setAlias(e.target.value);
  };

  const handleOpenJoinCompanyModal = () => { setJoinCompanyModalTrigger(true) };
  const handleCloseJoinCompanyModal = () => {
    setJoinCompanyModalTrigger(false);
    handleClearJoinCompanyStates();
  };

  const handleJoinCompanyCode = (e) => {
    setIsJoinCompanyCodeError(false)
    setJoinCompanyCode(e.target.value)
  }

  const handleJoinCompany = (e) => {
    e.preventDefault()
    if (joinCompanyCode) {
      setJoinCompanyLoading(true)
      let formData = new FormData();
      formData.append("company_code_chr", joinCompanyCode);

      dispatch(
        joinCompanyApi(
          formData,
          (res) => {
            setJoinCompanyLoading(false);
            setResponceMsg(res.data.message);
            setToasterType("success");

            handleCloseJoinCompanyModal();

            // setHandleToaster(true);
            // setTimeout(() => {
            //   setHandleToaster(false);
            // }, 4000);
          },
          (err) => {
            setJoinCompanyLoading(false);
            setResponceMsg(err.data.message);
            setToasterType("error");
            setHandleToaster(true);

            setVerifyUserLoading(false);
            setIsJoinCompanyCodeError(true);

            setTimeout(() => {
              setHandleToaster(false);
            }, 11000);
          }
        )
      );
    } else {
      setIsJoinCompanyCodeError(true)
    }
  }

  const handleClearJoinCompanyStates = () => {
    setJoinCompanyCode('');
    setIsJoinCompanyCodeError(false);
    setJoinCompanyLoading(false);

  }

  // Verification emial and mobile starts here------------------
  useEffect(() => {
    if (resendCodeCheck && resendCodeTimer > 0) {
      intervalId.current = setInterval(
        () => setResendCodeTimer((prev) => prev - 1),
        1000
      );
    } else if (!resendCodeCheck || resendCodeTimer === 0) {
      clearInterval(intervalId.current);
    }

    if (resendCodeTimer === 0) {
      setResendCodeCheck(false);
    }
    return () => clearInterval(intervalId.current);
  }, [resendCodeCheck, resendCodeTimer]);

  function handleClearVerifyEmailPhoneStates() {
    setEmailNew("");
    setPhoneNumberNew();
    setCountryCodeNewNew(1);
    setIsEmailErrorNew(false);
    setIsPhoneErrorNew(false);
    setCheckAfterVerificationCodeSend(false);
    setResendCodeCheck(false);
    setResendCodeTimer(60);
    setRecievedCodeValue("");
    setVerifyUserLoading(false);
    setIsCodeError(false);
    setIsVerificationCodeSendDirectly(false);
  }

  const handleEmailNew = (e) => {
    setIsEmailErrorNew(false);
    noSpaceOnChange(e.target.value) && setEmailNew(e.target.value);
  };

  function handleEmailBlurCheckNew() {
    if (!emailValidation(emailNew)) {
      setIsEmailErrorNew(true);
      if (emailNew === "") {
        setErrorEmailMsg("Please enter email");
      } else {
        setErrorEmailMsg(validEmailText);
      }
    }
  }

  const handlePhonenumberNew = (e) => {
    setIsPhoneErrorNew(false);
    phoneOnChange(e.target.value) && setPhoneNumberNew(e.target.value);
  };



  const handleCountryCodeNew = (e) => {
    // setCountryCodeNewNew(e.target.value);
    setCountryCodeNewNew(e);
  };

  function handlePhonenumberBlurCheckNew() {
    if (
      (!phoneValidation(phoneNumberNew) && phoneNumberNew == "") ||
      phoneNumberNew.length !== 10
    ) {
      setIsPhoneErrorNew(true);
    }
  }

  function handleVerify(e) {
    e?.preventDefault();
    setVerifyUserLoading(true);

    // setResendCodeCheck(true);
    // setResendCodeTimer(60);

    if (checkForEmailVerification) {
      if (!emailValidation(emailNew)) {
        setIsEmailErrorNew(true);
        if (emailNew === "") {
          setErrorEmailMsg("Please enter email");
          setVerifyUserLoading(false);
        } else {
          setErrorEmailMsg(validEmailText);
          setVerifyUserLoading(false);
        }
      } else {
        // console.log("email verification", emailNew)

        let formData = new FormData();
        formData.append("phone_code_id_int", 0);
        formData.append("phone_number_int", 0);
        formData.append("email_chr", emailNew);
        !isVerificationCodeSendDirectly &&
          formData.append("user_id_ids", localStorage.getItem("user_id"));

        // console.log("phone_code_id_int", 0)
        // console.log("phone_number_int", 0)
        // console.log("email_chr", emailNew)
        // console.log("user_id_ids", localStorage.getItem('user_id'))

        dispatch(
          resendCode(
            formData,
            (res) => {
              setResponceMsg(res.data.message);
              setToasterType("success");

              setVerifyUserLoading(false);
              setCheckAfterVerificationCodeSend(true);
              setResendCodeCheck(true);
              setResendCodeTimer(60);

              // setHandleToaster(true);
              // setTimeout(() => {
              //   setHandleToaster(false);
              // }, 11000);
            },
            (err) => {
              setResponceMsg(err.data.message);
              setToasterType("error");
              setHandleToaster(true);

              setVerifyUserLoading(false);

              setTimeout(() => {
                setHandleToaster(false);
              }, 11000);
            }
          )
        );
      }
    }
    if (checkForPhoneVerification) {
      if (!phoneValidation(phoneNumberNew) && !isVerificationCodeSendDirectly) {
        setIsPhoneErrorNew(true);
        setVerifyUserLoading(false);
      } else {
        // console.log("phone verification", phoneNumberNew, "country code", countryCodeNewNew)

        let formData = new FormData();
        formData.append("phone_code_id_int", parseInt(countryCodeNewNew));
        formData.append("phone_number_int", parseInt(phoneNumberNew));
        formData.append("email_chr", "");
        !isVerificationCodeSendDirectly &&
          formData.append("user_id_ids", localStorage.getItem("user_id"));

        // console.log("phone_code_id_int", parseInt(countryCodeNewNew))
        // console.log("phone_number_int", parseInt(phoneNumberNew))
        // console.log("email_chr", "")
        // console.log("user_id_ids", localStorage.getItem('user_id'))

        dispatch(
          resendCode(
            formData,
            (res) => {
              setResponceMsg(res.data.message);
              setToasterType("success");

              setVerifyUserLoading(false);
              setCheckAfterVerificationCodeSend(true);
              setResendCodeCheck(true);
              setResendCodeTimer(60);

              // setHandleToaster(true);
              // setTimeout(() => {
              //   setHandleToaster(false);
              // }, 11000);
            },
            (err) => {
              setResponceMsg(err.data.message);
              setToasterType("error");
              setHandleToaster(true);

              setVerifyUserLoading(false);

              setTimeout(() => {
                setHandleToaster(false);
              }, 11000);
            }
          )
        );
      }
    }
  }

  function handleValidateCode(e) {
    setIsCodeError(false);
    setRecievedCodeValue(e.target.value);
  }

  function handleGetUserById(e) {
    let details = {
      user_id_ids: localStorage.getItem("user_id"),
      role_id_int: localStorage.getItem("roleId"),
      user_impersonate_flag: 0,
    };

    dispatch(
      userById(
        details,
        (res) => {
          setApiResponse(false);
          setAvatarArr(res.data.data.avatar_list);
          setInitialState(res);
          setRoleArr(res.data.data.roles);
          dispatch(setUserDetails(res.data.data));
          localStorage.setItem("triggerFlag", res.data.data.is_available_ysn);
        },
        (err) => { }
      )
    );
  }
  function hanldeActivateUser(e) {
    e?.preventDefault();
    setVerifyUserLoading(true);

    if (checkForEmailVerification) {
      if (recievedCodeValue !== "") {
        // console.log("activate user", recievedCodeValue)

        let formData = new FormData();
        formData.append("phone_code_id_int", 0);
        formData.append("phone_number_int", 0);
        formData.append("email_chr", emailNew);
        formData.append("otp_chr", recievedCodeValue);
        !isVerificationCodeSendDirectly &&
          formData.append("user_id_ids", localStorage.getItem("user_id"));

        // console.log("phone_code_id_int", 0)
        // console.log("phone_number_int", 0)
        // console.log("email_chr", emailNew)
        // console.log("otp_chr", recievedCodeValue)
        // console.log("user_id_ids", localStorage.getItem('user_id'))

        dispatch(
          activateUser(
            formData,
            (res) => {
              setResponceMsg(res.data.message);
              setToasterType("success");

              setVerifyUserLoading(false);
              handleCloseVerifyModal();
              handleGetUserById()

              // setHandleToaster(true);
              // setTimeout(() => {
              //   setHandleToaster(false);
              // }, 11000);
            },
            (err) => {
              setIsCodeError(true);

              setResponceMsg(err.data.message);
              setToasterType("error");

              setVerifyUserLoading(false);

              // setHandleToaster(true);
              // setTimeout(() => {
              //   setHandleToaster(false);
              // }, 11000);
            }
          )
        );
      } else {
        setIsCodeError(true);
        setVerifyUserLoading(false);
      }
    }
    if (checkForPhoneVerification) {
      if (recievedCodeValue !== "") {
        // console.log("activate user", recievedCodeValue)

        let formData = new FormData();
        formData.append("phone_code_id_int", parseInt(countryCodeNewNew));
        formData.append("phone_number_int", parseInt(phoneNumberNew));
        formData.append("email_chr", "");
        formData.append("otp_chr", recievedCodeValue);
        !isVerificationCodeSendDirectly &&
          formData.append("user_id_ids", localStorage.getItem("user_id"));

        // console.log("phone_code_id_int", parseInt(countryCodeNewNew))
        // console.log("phone_number_int", parseInt(phoneNumberNew))
        // console.log("email_chr", "")
        // console.log("otp_chr", recievedCodeValue)
        // console.log("user_id_ids", localStorage.getItem('user_id'))

        dispatch(
          activateUser(
            formData,
            (res) => {
              setResponceMsg(res.data.message);
              setToasterType("success");

              setVerifyUserLoading(false);
              handleCloseVerifyModal();

              handleGetUserById()

              // setHandleToaster(true);
              // setTimeout(() => {
              //   setHandleToaster(false);
              // }, 11000);
            },
            (err) => {
              setIsCodeError(true);

              setResponceMsg(err.data.message);
              setToasterType("error");
              setHandleToaster(true);

              setVerifyUserLoading(false);

              setTimeout(() => {
                setHandleToaster(false);
              }, 11000);
            }
          )
        );
      } else {
        setIsCodeError(true);
        setVerifyUserLoading(false);
      }
    }
  }

  function handleOpenVerifyModal(data) {
    setTriggerForVerifyModal(true);
    if (data === "email") {
      setCheckForEmailVerification(true);
      setCheckForPhoneVerification(false);
    }
    if (data === "phone") {
      setCheckForPhoneVerification(true);
      setCheckForEmailVerification(false);
    }
  }

  function handleDirectlyResendCode(e, data) {
    if (data === "email") {
      setCheckForEmailVerification(true);
      setCheckForPhoneVerification(false);

      setEmailNew(email);
    }
    if (data === "phone") {
      setCheckForPhoneVerification(true);
      setCheckForEmailVerification(false);

      setCountryCodeNewNew(countryCode);
      setPhoneNumberNew(phonenumber);
    }

    setTriggerForVerifyModal(true);
    setCheckAfterVerificationCodeSend(true);
    setIsVerificationCodeSendDirectly(true);
  }

  useEffect(() => {
    if (checkAfterVerificationCodeSend && isVerificationCodeSendDirectly) {
      handleVerify();
    }
  }, [checkAfterVerificationCodeSend]);

  function handleCloseVerifyModal() {
    setTriggerForVerifyModal(false);
    handleClearVerifyEmailPhoneStates();
    setAccountDetailsModalTrigger(true);
  }
  // Verification emial and mobile ends here------------------

  // Tooltips here
  const tooltipDelete = (
    <Tooltip id="tooltip">
      <strong>Delete Account</strong>
    </Tooltip>
  );

  // International phone number formator
  useEffect(() => {
    if (phonenumber == null || phonenumber == "") {
      setPhoneNumberFormat(null);
    } else {
      setPhoneNumberFormat(
        InternationalPhoneFormatFun(`${countryCodeNew}`, `${phonenumber}`)
      );
    }
  }, [phonenumber]);

  // Set the role name of user
  const userRole = (str) => {

    const lowerCaseStr = str.toLowerCase();
    setRoleName(lowerCaseStr.charAt(0).toUpperCase() + lowerCaseStr.slice(1));
  };

  const setInitialState = (res) => {

    setFirstName(res.data.data.first_name_chr);
    setLastName(res.data.data.last_name_chr);
    setAlias(res.data.data.alias_name_chr ? res.data.data.alias_name_chr : "");
    setBioText(res.data.data.bio_text);
    setAddress(res.data.data.complete_address_chr);
    setCountryCode(
      res.data.data.phone_code_id_lng === null
        ? 0
        : res.data.data.phone_code_id_lng
    );
    setPhonenumber(
      res.data.data.phone_number_int === null
        ? 0
        : res.data.data.phone_number_int
    );
    setEmail(res.data.data.email_chr);
    setUserName(res.data.data.user_name_chr);
    setAvatarUrl(res.data.data.preferred_profile_picture_url);
    setAvatarId(res.data.data.avatar_id_lng);
    setAddressLine1(res.data.data.address.address_line_1_chr);
    setAddressLine2(res.data.data.address.address_line_1_chr);
    if (Object.keys(res?.data?.data?.address).length > 0) {
      res.data.data.address.zip_code_int && setZipCode(res.data.data.address.zip_code_int);
    }
    setStateName(res.data.data.address.state_name_chr);
    setCityName(res.data.data.address.city_name_chr);
    setCountryName(res.data.data.address.country_name_chr);
    setLatVal(res.data.data.address.latitude_float);
    setLongVal(res.data.data.address.longitute_float);
    setCountryCodeNew(res.data.data.country_phone_code_chr);
    setAddress(res.data.data.complete_address_chr);
    setPlaceId(res.data.data.address.place_id_chr);
    userRole(res.data.data.role_name_chr);
    setChangedRoleId(res.data.data.role_id_int);

    setIsEmailConfirmed(res.data.data.email_confirmed_ysn);
    setIsPhoneConfirmed(res.data.data.phone_number_confirmed_ysn);
    setRoleIHave(res.data.data.role_list);
    setCompanyId(res.data.data.company_id_lng);
    setAssociatedCompanyName(res?.data?.data?.company_name_chr);

    setProCodeDetails(res?.data?.data?.pro_code_details);

  };

  useEffect(() => {
    handleGetUserById()
  }, []);


  function updateProfile(e) {
    e.preventDefault();

    if (firstNameValidation(firstName)) {

      setUpdateProfileLoading(true);


      const profileData = new FormData();

      profileData.append(
        "user_id_ids", localStorage.getItem("user_id"));
      profileData.append("first_name_chr", firstName || "");
      profileData.append("last_name_chr", lastName || "");
      profileData.append("alias_name_chr", alias || "");
      profileData.append("bio_text", bioText || "");
      profileData.append("phone_code_id_int", +countryCode || 0);
      profileData.append("phone_number_int", +phonenumber || 0);
      profileData.append("place_id_chr", placeIdVal || " ");
      profileData.append("address_line_1_chr", addressLine1 || " ");
      profileData.append("address_line_2_chr", addressLine2 || " ");
      {
        photoToUpload != null
          ? profileData.append("default_image_flag", 1)
          : profileData.append("default_image_flag", 0);
      }
      profileData.append("city_name_chr", cityName || "");
      profileData.append("state_name_chr", stateName || "");
      profileData.append("country_name_chr", countryName || "");
      profileData.append("zip_code_int", zipCode || 0);
      profileData.append("longitute_float", longVal || 0.0);
      profileData.append("latitude_float", latVal || 0.0);
      profileData.append("complete_address_chr", address ? address : "");
      profileData.append("avatar_id_int", avatarId);
      {
        photoToUpload != null &&
          profileData.append(
            "profile_picture",
            photoToUpload,
            "profilePhoto.png"
          );
      }

      roleIHave.map((item) => {
        profileData.append("role_id_list", item);
      })

      profileData.append("company_id_ids", companyId || '');


      dispatch(
        updateUserApi(
          profileData,
          (res) => {
            setResponceMsg(res.data.message);
            setToasterType("success");

            handleGetUserById()

            setUpdateProfileLoading(false);
            // setApiResponse(false);

            // setHandleToaster(true);
            // setTimeout(() => {
            //   setHandleToaster(false);
            // }, 11000);

            handleCloseAccountDetailsModal();

            // resp()
          },
          (res) => {
            setResponceMsg(res.data.message);
            setToasterType("error");
            setUpdateProfileLoading(false);
            // setApiResponse(false);

            setHandleToaster(true);
            setTimeout(() => {
              setHandleToaster(false);
            }, 11000);
          }
        )
      );
    } else {
      setIsFirstNameError(true);
      setApiResponse(false);
    }
  }

  // Functions for handling the Bio form data
  const handleFirstName = (e) => {
    setIsFirstNameError(false);
    setFirstName(e.target.value);
  };
  const handleLastName = (e) => {
    setLastName(e.target.value);
  };

  const handleBioText = (e) => {
    setBioText(e.target.value);
  };

  const profileImgRef = useRef();

  const handleClickProfileImg = () => {
    profileImgRef.current.click();
  };

  function handlePhotoSelected(e) {
    setPhotoToUpload(e.target.files[0]);
    // console.log(e.target.files[0])
  }

  // Function to delete Account permently
  function deleteAccount() {
    let details = {
      user_id_ids: localStorage.getItem("user_id"),
    };
    setUpdateProfileLoading(true);
    dispatch(
      deleteUser(details, (res) => {
        setOpenDialog(false);
        setUpdateProfileLoading(false);
        localStorage.removeItem("user_id");
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("username_chr");
        localStorage.removeItem("name");
        localStorage.removeItem("access_token");
        localStorage.removeItem("fcm_token");
        dispatch(signout());
        navigate("/");
        handleCloseAccountDetailsModal();
        dispatch(resetState());
      }, () => {
        setUpdateProfileLoading(false);
      })
    );
  }

  function hanldeChangeAddress(e) {
    setSearchText(e.target.value);
  }

  useEffect(() => {
    const timeOutId = setTimeout(searchCalling, 1000);
    return () => clearTimeout(timeOutId);
  }, [searchText]);

  function searchCalling() {
    if (searchText.trim().length > 2) {
      let details = {
        address_chr: searchText.trim(),
      };
      dispatch(
        searchAddress(details, (res) => {
          setAddressArr(res.data.data);
        })
      );
    }
  }

  const popover = (
    <Popover
      id="popover-basic"
      className="custom-popover"
      style={{ minWidth: "308px" }}>
      <Popover.Body
        style={{
          padding: "5px",
          boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.2)",
        }}>
        <div className="d-flex " style={{}}>
          {avatarArr.map((ele, index) => (
            <>
              <span key={index} style={{ cursor: "pointer", margin: "1px" }}>
                <Avatar
                  src={ele.avatar_url_chr}
                  size="35"
                  alt=""
                  onClick={() => {
                    setPhotoToUpload(null);
                    setAvatarUrl(ele.avatar_url_chr);
                    setAvatarId(ele.avatar_id_ids);
                    setUpdateBtn(true);
                  }}
                />
              </span>
            </>
          ))}
          <div
            style={{
              cursor: "pointer",
              margin: "1px",
              backgroundColor: "white",
            }}>
            <Button
              onClick={handleClickProfileImg}
              className="custom-profile-btn"
              variant="outline-primary">
              <i className="bi bi-plus"></i>
            </Button>
            <input
              ref={profileImgRef}
              onChange={handlePhotoSelected}
              type="file"
              accept="image/*"
              hidden
            />
          </div>
        </div>
      </Popover.Body>
    </Popover>
  );

  const handleSelect = (newValue) => {
    // console.log(newValue.place_id, "newValue");
    setPlaceId(newValue.place_id);
    let details = {
      place_id: newValue.place_id,
    };
    // dispatch(addressByPlaceId(details, (res) => {
    //   setUpdateBtn(true)
    //   setStateName(res.data.data.complete_address.state_name_chr)
    //   setZipCode(res.data.data.complete_address.zip_code_int)
    //   setCityName(res.data.data.complete_address.city_name_chr)
    //   setCountryName(res.data.data.complete_address.country_name_chr)
    //   setLongVal(res.data.data.location.lng)
    //   setLatVal(res.data.data.location.lat)
    //   setAddress(res.data.data.formatted_address)
    //   setAddressLine1(res.data.data.complete_address.address_line_1_chr)
    //   setAddressLine2(res.data.data.complete_address.address_line_2_chr)
    // }))
  };
  function handleFirstNameBlurCheck() {
    if (!firstNameValidation(firstName)) {

      setIsFirstNameError(true);
    }
  }

  function handleSwitchRole() {
    let data = {
      role_id_int: localStorage.getItem("roleId")
    }
    dispatch(switchRoleApi(data, (res) => {
      localStorage.setItem("access_token", res.data.access_token)
      localStorage.setItem("refresh_token", res.data.refresh_token)
      dispatch(setUserDetails(res.data.data))
      userRole(res.data.data.role_name_chr)


      setResponceMsg(res.data.message);
      setToasterType("success");

      // setHandleToaster(true);
      // setTimeout(() => {
      //   setHandleToaster(false);
      // }, 11000);
    }, (err) => {
      setResponceMsg(err.data.message);
      setToasterType("error");
      setHandleToaster(true);
      setTimeout(() => {
        setHandleToaster(false);
      }, 11000);
    }))
  }
  function changeRole(e) {
    //     setChangeRoleModal(true)
    setChangedRoleId(e.target.value)
    localStorage.setItem("roleId", e.target.value)
    handleSwitchRole()

  }

  function changeRoleAccepted(e) {
    // localStorage.setItem("roleId", changedRoleId)
    // handleSwitchRole()
    setChangeRoleModal(false)

  }

  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;




  const handleOpenAccountDetailsModal = () => {
    setAccountDetailsModalTrigger(true);
  }

  const handleCloseAccountDetailsModal = () => {
    setAccountDetailsModalTrigger(false);

    setToggleAccountDetailsModal(1);
  }

  const [toggleAccountDetailsModal, setToggleAccountDetailsModal] = useState(1);

  const handleBackAccountDetailsModal = (value) => {
    setToggleAccountDetailsModal(value);
  }

  const handleProfileAvatar = (ele) => {
    setPhotoToUpload(null);
    setAvatarUrl(ele.avatar_url_chr);
    setAvatarId(ele.avatar_id_ids);
    setUpdateBtn(true);
  }

  const handleCodeBlurCheck = () => {
    if (recievedCodeValue === "") {
      setIsCodeError(true);
    }
  }

  // Modal triggers for the Change Password
  const [showChangePassword, setShowChangePassword] = useState(false);

  const handleCloseChangePassword = (data, message) => {

    if (data == "success") {
      setToasterType("success")
      setResponceMsg(message)


      // setHandleToaster(true)
      // setTimeout(() => {
      //   setHandleToaster(false);
      // }, 11000);
    }
    setShowChangePassword(false)
  };
  const handleShowChangePassword = () => setShowChangePassword(true);

  // Add company by user functions
  const [companyModal, setCompanyModal] = useState(false)
  const [companyModalType, setCompanyModalType] = useState("")
  const [companyData, setCompanyData] = useState(``)

  const handleCloseCompanyModal = () => {
    setCompanyModal(false);
    handleGetUserById();
  }

  const handleOpenRegisterComp = () => {
    setCompanyModal(true)
    setCompanyModalType("add");

    handleCloseJoinCompanyModal();
    // setJoinCompanyModalTrigger(false);
    // setJoinCompanyCode('');
    // setIsJoinCompanyCodeError(false);
    // setJoinCompanyLoading(false);
  }

  const copyToClipboard = () => {
    setResponceMsg("Code copied to clipboard!");
    setToasterType("success");

    setHandleToaster(true);
    setTimeout(() => {
      setHandleToaster(false);
    }, 11000);
  };

  return (
    <>
      <Card className='w-100' style={{ position: 'relative' }}>
        <div className='row mx-0  w-100 h-100'>
          <div className='col-12 d-flex flex-column justify-content-between lh-lg p-4' style={{}}>
            <div>
              <div className='row border-3 border-bottom border-white mx-0 pb-2'>
                <div className='col-9 fs-4 fw-bold px-0 text-black'>
                  <span>{"Account details"}</span>
                </div>
                <div className='col-3 fs-4 font-w500 px-0 text-end'>
                  <span onClick={handleOpenAccountDetailsModal} className='cursor-pointer overlay-action-btn px-2 rounded-1'>{"Edit"}</span>
                </div>
              </div>


              <div className='row border-3 border-bottom border-white mx-0 py-1 fs-7'>
                <div className='col-6 fw-normal px-0'>
                  <span>{"First name"}</span>
                </div>
                <div className='col-6 px-0 text-black font-w500'>
                  <span>{firstName}</span>
                </div>
              </div>

              <div className='row border-3 border-bottom border-white mx-0 py-1 fs-7'>
                <div className='col-6 fw-normal px-0'>
                  <span>{"Last name"}</span>
                </div>
                <div className={`col-6 px-0 ${lastName ? 'text-black' : ''} font-w500`}>
                  <span>{lastName ? lastName : "Not specified"}</span>
                </div>
              </div>

              <div className='row border-3 border-bottom border-white mx-0 py-1 fs-7'>
                <div className='col-6 fw-normal px-0'>
                  <span>{"Alias name"}</span>
                </div>
                <div className={`col-6 px-0 ${lastName ? 'text-black' : ''} font-w500`}>
                  <span>{alias ? alias : "Not specified"}</span>
                </div>
              </div>

              <div className='row border-3 border-bottom border-white mx-0 py-1 fs-7'>
                <div className='mx-0 px-0 row'>
                  <div className='col-6 fw-normal px-0'>
                    <span>{"Email"}</span>
                  </div>
                  <div className={`col-6 px-0 text-black font-w500 ${email ? 'text-black' : ''}`}>
                    <span>{email ? email : "Not specified"}</span>
                  </div>
                </div>

                <div className='mx-0 px-0 row fs-7'>
                  <div className='col-6 fw-normal px-0'>
                    <span>{ }</span>
                  </div>

                  {isEmailConfirmed ?
                    <>
                      <div className='col-6 px-0 text-success font-w500'>
                        <i className="bi bi-patch-check-fill pe-2"></i>
                        <span>{"verified"}</span>
                      </div>
                    </> : <></>
                  }
                </div>
              </div>

              <div className='row border-3 border-bottom border-white mx-0 py-1 fs-7'>
                <div className='mx-0 px-0 row'>
                  <div className='col-6 fw-normal px-0'>
                    <span>{"Phone"}</span>
                  </div>
                  <div className={`col-6 px-0 font-w500 ${phoneNumberFormat ? 'text-black' : ''}`}>
                    <span>{phoneNumberFormat != null ? phoneNumberFormat : "Not specified"}</span>
                  </div>
                </div>

                <div className='mx-0 px-0 row fs-7'>
                  <div className='col-6 fw-normal px-0'>
                    <span>{ }</span>
                  </div>

                  {isPhoneConfirmed != 0 &&
                    <div className='col-6 px-0 text-success font-w500'>
                      <i className="bi bi-patch-check-fill pe-2"></i>
                      <span>{`verified`}</span>
                    </div>
                  }
                </div>
              </div>




              <div className='row border-3 border-bottom border-white mx-0 py-1 fs-7'>
                <div className='col-6 fw-normal px-0'>
                  <span>{"Address"}</span>
                </div>
                <div className={`col-6 px-0  font-w500 ${address ? 'text-black' : ''}`}>
                  <span>{address ? address : "Not specified"}</span>
                </div>
              </div>

              <div className='row border-3 border-bottom border-white mx-0 py-1 fs-7'>
                <div className='col-6 fw-normal px-0'>
                  <span>{"Zip code"}</span>
                </div>
                <div className={`col-6 px-0  font-w500 ${address ? 'text-black' : ''}`}>
                  <span>{zipCode ? zipCode : "Not specified"}</span>
                </div>
              </div>

              <div className='row border-3 border-bottom border-white mx-0 py-1 fs-7'>
                <div className='col-6 fw-normal px-0'>
                  <span>{"Time zone"}</span>
                </div>
                <div className='col-6 px-0 text-black font-w500'>
                  <span>{timeZone}</span>
                </div>
              </div>

              <div className='row border-3 border-bottom border-white mx-0 py-1 fs-7'>
                <div className='col-6 fw-normal px-0'>
                  <span>{"Bio"}</span>
                </div>
                <div className={`col-6 px-0 font-w500 ${bioText ? 'text-black' : ''}`}>
                  <span>{bioText ? bioText : "Not specified"}</span>
                </div>
              </div>

              {Object.keys(proCodeDetails).length > 0 && permissionArray.includes("UPDATE WORK INFORMATION") &&
                <div className='row border-3 border-bottom border-white mx-0 py-1 fs-7'>
                  <div className='col-6 fw-normal px-0 d-flex '>
                    <span>{"Pro code"}</span>

                    <div className="ms-2 d-flex ">
                      <div className="tooltipCustom ">
                        <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{`Pro code is used while creating service requests`}</span>
                        <span

                          className={`cursor-pointer text-hovered`}
                        >
                          <IoInformationCircleOutline style={{ fontSize: "12px" }} />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className={`col-6 px-0 font-w500 d-flex flex-column ${proCodeDetails?.promo_code_str ? 'text-black' : ''}`}>

                    <div className="d-flex align-items-center">
                      <span>{proCodeDetails?.promo_code_str ? proCodeDetails?.promo_code_str : "Not specified"}</span>

                      <div className="ms-2 d-flex align-items-center">
                        <div className="tooltipCustom ">
                          <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Copy to clipboard"}</span>
                          <span
                            onClick={() => {
                              navigator.clipboard.writeText(
                                `${proCodeDetails?.promo_code_str}`
                              );
                              copyToClipboard()
                            }}
                            className={`cursor-pointer text-hovered`}
                          >
                            <MdContentCopy style={{ fontSize: "12px" }} />
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="d-flex align-items-center mt-1 ">
                      <span
                        className="cursor-pointer overlay-action-btn p-1 px-0 pe-1 px"
                        onClick={handleOpenProCodeModal}
                      >
                        {`Share your pro code`}
                        <i className="bi bi-share-fill ms-2"></i>
                      </span>
                    </div>

                  </div>
                </div>
              }

            </div>

            <div className="mt-5">
              {/* {!companyId && permissionArray.includes("REGISTER COMPANY") &&
                <div className='row mx-0 '>
                  <div className='col-8 fs-6 px-0'>
                    <div className='d-flex'>
                      <div onClick={() => {
                        setCompanyModal(true)
                        setCompanyModalType("add")
                      }}
                        className='align-items-center text-black font-w500 rounded-1 cursor-pointer d-flex overlay-action-btn px-2 text-hovered'>
                        <span>{`Register company`} </span>
                        <i className="bi bi-chevron-right ps-2 hovered-arrow"></i>
                      </div>
                    </div>
                  </div>
                  <div className='col-4'></div>
                </div>
              } */}

              {/* {!companyId && permissionArray.includes("REGISTER COMPANY") &&
                <div className='row mx-0 '>
                  <div className='col-12 fs-6 px-0'>
                    <div className='d-flex'>
                      {inProgressServiceCount == 0 ?
                        <>
                          <div
                            onClick={() => {
                              handleOpenJoinCompanyModal()
                            }}
                            className='align-items-center text-black font-w600 rounded-1 cursor-pointer d-flex overlay-action-btn px-2 text-hovered'
                          >
                            <span>{`Join company`} </span>
                            <i className="bi bi-chevron-right ps-2 hovered-arrow"></i>
                          </div>
                        </> :
                        <>
                          <OverlayTrigger placement="top" overlay={joinInfo}>
                            <div
                              className='align-items-center text-black font-w600 rounded-1 cursor-pointer d-flex overlay-action-btn px-2 op6'
                            >
                              <span>{`Join company`} </span>
                              <i className="bi bi-chevron-right ps-2 hovered-arrow"></i>
                            </div>
                          </OverlayTrigger>
                        </>
                      }

                    </div>
                  </div>
                </div>
              } */}


              {companyId && permissionArray.includes("VIEW OPEN SERVICE REQUESTS") && associatedCompanyName &&
                <div className='row mx-0 mb-3'>
                  <div className='col-12 px-0'>
                    <div className='d-flex'>
                      <div onClick={() => {
                        navigate("/companyManagement")
                      }}
                        className='rounded-1 d-flex px-2 flex-column fs-6'
                        style={{ lineHeight: "1.5" }}
                      >
                        <span className="">
                          {`Associated with`}
                        </span>
                        <span className="text-black font-w600 text-hovered overlay-action-btn cursor-pointer ">
                          {`${associatedCompanyName}`}
                        </span>
                        {/* <i className="bi bi-chevron-right ps-2 hovered-arrow"></i> */}
                      </div>
                    </div>
                  </div>
                </div>
              }

              {/* {companyId && permissionArray.includes("VIEW COMPANY USERS") &&
                <div className='row mx-0 '>
                  <div className='col-12 fs-6 px-0'>
                    <div className='d-flex'>
                      <div onClick={() => {
                        setCompanyModal(true)
                        if (permissionArray.includes("UPDATE COMPANY DETAIL")) {
                          setCompanyModalType("edit")
                        } else {
                          setCompanyModalType("view")
                        }
                      }}
                        className='align-items-center text-black font-w600 rounded-1 cursor-pointer d-flex overlay-action-btn px-2 text-hovered'>
                        <span>
                          {`${permissionArray.includes("UPDATE COMPANY DETAIL") ? "Edit company details" : "View company details"}`}

                        </span>
                        <i className="bi bi-chevron-right ps-2 hovered-arrow"></i>
                      </div>
                    </div>
                  </div>
                </div>
              } */}

              {/* {companyId && permissionArray.includes("UPDATE COMPANY DETAIL") &&
                <div className='row mx-0 '>
                  <div className='col-8 fs-6 px-0'>
                    <div className='d-flex'>
                      <div onClick={() => {
                        setCompanyModal(true)
                        setCompanyModalType("edit")
                      }}
                        className='align-items-center text-black font-w500 rounded-1 cursor-pointer d-flex overlay-action-btn px-2 text-hovered'>
                        <span>{`Edit company details`} </span>
                        <i className="bi bi-chevron-right ps-2 hovered-arrow"></i>
                      </div>
                    </div>
                  </div>
                  <div className='col-4'></div>
                </div>
              }
              {companyId && permissionArray.includes("VIEW COMPANY DETAIL") &&
                <div className='row mx-0 '>
                  <div className='col-8 fs-6 px-0'>
                    <div className='d-flex'>
                      <div onClick={() => {
                        setCompanyModal(true)
                        setCompanyModalType("view")
                      }}
                        className='align-items-center text-black font-w500 rounded-1 cursor-pointer d-flex overlay-action-btn px-2 text-hovered'>
                        <span>{`View company details`} </span>
                        <i className="bi bi-chevron-right ps-2 hovered-arrow"></i>
                      </div>
                    </div>
                  </div>
                  <div className='col-4'></div>
                </div>
              } */}

              <div className='row mx-0 mt-1 '>
                <div className='col-12 fs-6 px-0'>
                  <div className='d-flex'>
                    <div onClick={handleShowChangePassword} className='align-items-center text-black font-w600 rounded-1 cursor-pointer d-flex overlay-action-btn px-2'>
                      <span>{"Change password"} </span>
                      <i className="bi bi-chevron-right ps-2 hovered-arrow"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        {apiResponse && <ResponceForAPI show={apiResponse} />}

      </Card >



      {/* Modal for the Edit Account Details */}

      <Modal className="fade " show={accountDetailsModalTrigger} centered>
        <Modal.Body >

          <div className='row mx-0'>
            <div className='col-12 px-0 '>

              {/* Update Account details  */}
              {toggleAccountDetailsModal === 1 &&
                <>
                  <div className='mx-0 row'>
                    <div className="align-items-center col-6 d-flex font-w500 fs-5 justify-content-start px-0" >
                      {toggleAccountDetailsModal !== 1 &&
                        <div onClick={() => handleBackAccountDetailsModal(1)} className="cursor-pointer">
                          <i className="bi bi-arrow-left "></i>
                          <span className="ps-2">Back</span>
                        </div>
                      }

                    </div>

                    <div className='col-6 d-flex fs-4 justify-content-end px-0 text-black'>
                      <span onClick={() => handleCloseAccountDetailsModal()} className='cursor-pointer'>
                        <i className="bi bi-x-lg"></i>
                      </span>
                    </div>
                  </div>

                  <div className='mx-0 row mb-4'>
                    <div className='col-12 font-w600 fs-3 px-0 text-center text-black '>
                      <span>
                        {"Edit account details"}
                      </span>
                    </div>
                  </div>


                  <div className='row mx-0 justify-content-between mb-4' >
                    <div className='align-items-center col-4 d-flex justify-content-center px-0 '>
                      <div className="d-flex align-items-center justify-content-center border rounded-circle" style={{ width: "55px", height: "55px" }}>
                        <img src={
                          photoToUpload != null
                            ? URL.createObjectURL(photoToUpload)
                            : avatarUrl
                        } className='w-100 h-100 rounded-circle border' alt="profile" />
                      </div>
                    </div>

                    <div
                      className='col-4 d-flex font-w600  p-2 text-black overlay-action-btn cursor-pointer'
                      onClick={handleClickProfileImg}
                    >
                      <div className="d-flex align-items-center justify-content-center pe-2 fs-4">
                        <i className="bi bi-upload "></i>
                      </div>
                      <div
                        className="align-items-center d-flex flex-column"
                      >
                        <span>
                          {"Upload"}
                        </span>
                        <span>
                          {"photo"}
                        </span>

                        <input
                          ref={profileImgRef}
                          onChange={handlePhotoSelected}
                          type="file"
                          accept="image/*"
                          hidden
                        />
                      </div>
                    </div>

                    <div
                      className='col-4 d-flex font-w600  p-2  text-black overlay-action-btn cursor-pointer'
                      onClick={() => setToggleAccountDetailsModal(2)}
                    >
                      <div className="d-flex align-items-center justify-content-center pe-2 fs-4">
                        <i className="bi bi-emoji-smile "></i>
                      </div>
                      <div className="align-items-center d-flex flex-column ">
                        <span>
                          {"Choose"}
                        </span>
                        <span>
                          {"avatar"}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className='row mx-0 justify-content-between'>
                    <div className='col-md-6 px-0 pe-md-2'>
                      <InputField
                        labelName={lblFirstName}
                        placeholderName={lblFirstName}
                        onChange={handleFirstName}
                        onBlur={handleFirstNameBlurCheck}
                        errorOccured={isFirstNameError}
                        errorMeesage={validFirstName}
                        value={firstName}
                        isRequired={true}
                      />
                    </div>

                    <div className='col-md-6 px-0  ps-md-2'>
                      <InputField
                        labelName={lblLastName}
                        placeholderName={lblLastName}
                        onChange={handleLastName}
                        isError={false}
                        errorText={validLastName}
                        value={lastName}
                        errorOccured={""}
                        errorMeesage={""}
                      />
                    </div>

                  </div>

                  <div className="row mb-2">
                    <InputField
                      labelName={permissionArray.includes("UPDATE WORK INFORMATION") ? `Doing business as` : "Preferred name"}
                      value={alias}
                      onChange={(e) => { handleAlias(e) }}
                      errorOccured={false}
                      errorMeesage={""}
                      onBlur={() => { }}
                    />
                  </div>


                  <div className='row mx-0'>
                    <div className={`col-12 px-0 `}>
                      <UpdateEmailPhoneInputField
                        labelName={lblEmail}
                        value={email}
                        isVerified={isEmailConfirmed}
                        onClick={() => {
                          handleOpenVerifyModal("email");
                          setCheckForEmailVerification(true);
                          setAccountDetailsModalTrigger(false);
                        }}
                        handleDirectlyResendCode={(e) => {
                          handleDirectlyResendCode(e, "email");
                          setCheckForEmailVerification(true);
                          setAccountDetailsModalTrigger(false);
                        }}
                      />
                    </div>
                  </div>



                  <div className='row mx-0'>
                    <div className='col-12 px-0'>
                      <UpdateEmailPhoneInputField
                        labelName={txtMobileNumber}
                        value={phoneNumberFormat != null ? phoneNumberFormat : "-"}
                        isVerified={isPhoneConfirmed}
                        onClick={() => {
                          handleOpenVerifyModal("phone");
                          setCheckForPhoneVerification(true);
                          setAccountDetailsModalTrigger(false);
                        }}
                        handleDirectlyResendCode={(e) => {
                          handleDirectlyResendCode(e, "phone");
                          setCheckForPhoneVerification(true);
                          setAccountDetailsModalTrigger(false);
                        }}
                      />
                    </div>
                  </div>

                  <div className='row mx-0 mt-3'>
                    <div className='col-12 px-0'>
                      <InputField
                        labelName={"Bio"}
                        placeholderName={lblLastName}
                        onChange={handleBioText}
                        isError={false}
                        errorText={validLastName}
                        value={bioText}
                        errorOccured={""}
                        errorMeesage={""}
                      />
                    </div>
                  </div>

                  {/* <div className='row mx-0'>
                    <div className='col-12 px-0 mb-2'>
                      <label className="mb-1">
                        <strong>{"Address"}</strong>
                      </label>
                      <Select
                        isSearchable
                        name="color"
                        placeholder={address ? address : txtSearchAddress}
                        styles={{
                          control: (provided, state) => ({
                            ...provided,
                            // border: state.isFocused ? '1px solid #ced4da' : '1px solid #ced4da',
                            border: '1px solid #ced4da',
                            boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(0, 123, 255, 0)' : 'none',
                            width: '100%',
                            marginRight: '5px',
                            padding: '1px 3px',
                            '&:hover': {
                              border: '1px solid orange'
                            },
                            menu: (provided) => ({
                              ...provided,
                              zIndex: 5,
                            })
                          }),
                        }}
                        options={addressArr}
                        getOptionLabel={(option) => option.description}
                        getOptionValue={(option) => option.description}
                        onInputChange={setSearchText}
                        onChange={(option) => {
                          setPlaceId(option.place_id);
                          let details = {
                            place_id: option.place_id,
                          };
                          dispatch(
                            addressByPlaceId(details, (res) => {
                              setUpdateBtn(true);
                              setSearchText("");
                              setStateName(
                                res.data.data.complete_address.state_name_chr
                              );
                              res.data.data.complete_address.zip_code_int && setZipCode(res.data.data.complete_address.zip_code_int);
                              setCityName(
                                res.data.data.complete_address.city_name_chr
                              );
                              setCountryName(
                                res.data.data.complete_address.country_name_chr
                              );
                              setLongVal(res.data.data.location.lng);
                              setLatVal(res.data.data.location.lat);
                              setAddress(res.data.data.formatted_address);
                              setAddressLine1(
                                res.data.data.complete_address.address_line_1_chr
                              );
                              setAddressLine2(
                                res.data.data.complete_address.address_line_2_chr
                              );
                            })
                          );
                        }}
                      />
                    </div>
                  </div> */}

                  <div className='row mx-0'>
                    <div className='col-12 px-0'>

                      <SearchableSelectAddress
                        options={addressArr}
                        getOptionLabel={(option) => option.description}
                        getOptionValue={(option) => option.description}
                        handleChangeSearchValue={setSearchText}
                        handleSelectChange={(option) => {
                          setPlaceId(option.place_id);
                          let details = {
                            place_id: option.place_id,
                          };
                          dispatch(
                            addressByPlaceId(details, (res) => {
                              setUpdateBtn(true);
                              setSearchText("");
                              setStateName(
                                res.data.data.complete_address.state_name_chr
                              );
                              res.data.data.complete_address.zip_code_int && setZipCode(res.data.data.complete_address.zip_code_int);
                              setCityName(
                                res.data.data.complete_address.city_name_chr
                              );
                              setCountryName(
                                res.data.data.complete_address.country_name_chr
                              );
                              setLongVal(res.data.data.location.lng);
                              setLatVal(res.data.data.location.lat);
                              setAddress(res.data.data.formatted_address);
                              setAddressLine1(
                                res.data.data.complete_address.address_line_1_chr
                              );
                              setAddressLine2(
                                res.data.data.complete_address.address_line_2_chr
                              );
                            })
                          );
                        }}
                        labelName={"Address"}
                        placeholder={address ? address : txtSearchAddress}
                        errorOccured={false}
                        errorMessage={``}
                      />
                    </div>
                  </div>

                  <div className="row my-2">
                    <InputField
                      labelName={"Zip code"}
                      value={`${zipCode}`}
                      onChange={(e) => { setZipCode(e.target.value) }}
                      errorOccured={false}
                      errorMeesage={""}
                      onBlur={() => { }}
                    />
                  </div>




                  <div className='row mx-0 justify-content-between mt-2'>
                    <div className='col-md-6 px-0 pe-md-2 mb-2'>
                      <PrimaryButton
                        onClick={() => setToggleAccountDetailsModal(3)}
                        buttonName={"DELETE ACCOUNT"}
                        style={{
                          width: '100%',
                          background: 'linear-gradient(142.98deg, #E02D2D 1.99%, #FF5C5C 99.97%)',
                          border: '2px solid rgba(240, 72, 72, 1)',
                          boxShadow: '0px 6px 12px 0px rgba(240, 72, 72, 0.24)',
                          fontWeight: '600',
                        }}
                      />
                    </div>

                    <div className='col-md-6 px-0  ps-md-2 mb-2'>
                      <PrimaryButton
                        onClick={(e) => updateProfile(e)}
                        buttonName={"SAVE CHANGES"}
                        type={"submit"}
                        loadingMessage={btnUpdateProfileLoading}
                        isLoading={updateProfileLoading}
                        style={{
                          width: '100%',
                          background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                          border: '2px solid rgba(255, 154, 32, 1)',
                          boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                          fontWeight: '600',
                        }}
                      />
                    </div>

                  </div>
                </>}

              {/* Choose the profile from avatar list */}
              {toggleAccountDetailsModal === 2 &&
                <>
                  <div className='mx-0 row'>
                    <div className="align-items-center col-6 d-flex font-w500 fs-5 justify-content-start px-0" >
                      {toggleAccountDetailsModal !== 1 &&
                        <div onClick={() => handleBackAccountDetailsModal(1)} className="cursor-pointer">
                          <i className="bi bi-arrow-left "></i>
                          <span className="ps-2">Back</span>
                        </div>
                      }

                    </div>

                    <div className='col-6 d-flex fs-4 justify-content-end px-0 text-black'>
                      <span onClick={() => handleCloseAccountDetailsModal()} className='cursor-pointer'>
                        <i className="bi bi-x-lg"></i>
                      </span>
                    </div>
                  </div>

                  <div className='mx-0 row mb-4'>
                    <div className='col-12 font-w600 fs-3 px-0 text-center text-black '>
                      <span>
                        {"Choose avatar from list"}
                      </span>
                    </div>
                  </div>

                  {avatarArr.map((ele, index) => {
                    return (
                      <div key={index} className='mx-0 row lh-lg cursor-pointer overlay-action-btn ' onClick={() => { handleProfileAvatar(ele) }}>
                        <div className='col-12 font-w500 fs-4 px-0 text-center text-black '>
                          <div className={`${index !== (avatarArr.length - 1) && "border-bottom"} mx-0 p-2 row `}>

                            <div className="align-items-center col-3 d-flex justify-content-center px-0">
                              <div className="d-flex align-items-center justify-content-center border rounded-circle" style={{ width: "35px", height: "35px" }}>

                                <img src={ele.avatar_url_chr} className='w-100 h-100 rounded-circle border' alt="profile" />
                              </div>
                            </div>

                            <div className="align-items-cente col-7 d-flex px-0">
                              <span>
                                {ele.avatar_name_chr}
                              </span>
                            </div>

                            <div className="align-items-cente col-2 d-flex px-0 justify-content-end">
                              <input
                                className="form-check-input d-flex"
                                type="radio"
                                name="avatar"
                                value={ele.avatar_id_ids}
                                onChange={(e) => setAvatarId(ele.avatar_id_ids)}
                                checked={ele.avatar_id_ids === avatarId}
                              />
                            </div>
                          </div>

                        </div>
                      </div>
                    )
                  })}

                  <div className='row mx-0 justify-content-between mt-3'>
                    <div className='col-12 px-0 mb-2'>
                      <PrimaryButton
                        onClick={(e) => setToggleAccountDetailsModal(1)}
                        buttonName={"Confirm"}
                        style={{ width: "100%", }}
                      />
                    </div>
                  </div>
                </>
              }

              {/* Confirmation before deleting the account */}
              {toggleAccountDetailsModal === 3 &&
                <>
                  <div className='mx-0 row'>
                    <div className="align-items-center col-6 d-flex font-w500 fs-5 justify-content-start px-0" >
                      {toggleAccountDetailsModal !== 1 &&
                        <div onClick={() => handleBackAccountDetailsModal(1)} className="cursor-pointer">
                          <i className="bi bi-arrow-left "></i>
                          <span className="ps-2">Back</span>
                        </div>
                      }

                    </div>

                    <div className='col-6 d-flex fs-4 justify-content-end px-0 text-black'>
                      <span onClick={() => handleCloseAccountDetailsModal()} className='cursor-pointer'>
                        <i className="bi bi-x-lg"></i>
                      </span>
                    </div>
                  </div>

                  <div className='mx-0 row my-4'>
                    <div className='col-12 font-w600 fs-3 px-0 text-center text-black '>
                      <span>
                        {"Are you sure that you want to delete your account in Chilll?"}
                      </span>
                    </div>
                  </div>

                  <div className='mx-0 row'>
                    <div className='col-12 font-w500 fs-5 px-0 text-center  '>
                      <span>
                        {"Deleting your account is not reversible once the process is complete. If you are certain you wish to delete your account, click on below button."}
                      </span>
                    </div>
                  </div>

                  <div className='row mx-0 justify-content-between mt-4'>

                    <div className='col-md-6 pe-md-2 mb-2'>
                      <PrimaryButton
                        onClick={() => handleBackAccountDetailsModal(1)}
                        buttonName={"CANCEL"}
                        style={{
                          width: "100%",
                          backgroundColor: "white",
                          border: '1px solid black',
                          color: 'black',
                          fontWeight: '600',
                        }}
                      />
                    </div>

                    <div className='col-md-6 ps-md-2 mb-2'>
                      <PrimaryButton
                        onClick={deleteAccount}
                        buttonName={"DELETE ACCOUNT"}
                        loadingMessage={"DELETING..."}
                        isLoading={updateProfileLoading}
                        style={{
                          width: '100%',
                          background: 'linear-gradient(142.98deg, #E02D2D 1.99%, #FF5C5C 99.97%)',
                          border: '1px solid rgba(240, 72, 72, 1)',
                          boxShadow: '0px 6px 12px 0px rgba(240, 72, 72, 0.24)',
                          fontWeight: '600',
                        }}
                      />
                    </div>

                  </div>

                </>
              }

            </div>
          </div>

        </Modal.Body>
      </Modal>

      {/* <!-- Modal --> */}
      <Modal className="fade" show={basicModalDeleteAccount} style={{}}>
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ padding: "30px", flexDirection: "column" }}>
          <div
            style={{
              fontSize: "24px",
              fontWeight: "600",
              textAlign: "center",
              padding: "20px",
            }}>
            Are you sure you want to delete your account ?
          </div>

          <div>
            <WhiteGreenButton
              buttonName={"No"}
              onClick={() => setBasicModalDeleteAccount(false)}
              variant={"primary"}
              className={"white-background-btn"}
            />

            <WhiteGreenButton
              buttonName={"Yes"}
              onClick={deleteAccount}
              className={"green-background-btn"}
              variant={"primary"}
            />
          </div>
        </div>
      </Modal>

      {/* <!-- Join company flow --> */}
      <Modal
        className="fade"
        show={joinCompanyModalTrigger}
        style={{}}
        centered
      >
        <Modal.Body>
          <div className="row mx-0">
            <div className="col-12 px-0">

              <div className='mx-0 row'>
                <div className='col-12 d-flex fs-4 justify-content-end px-0 text-black'>
                  <span
                    onClick={() => handleCloseJoinCompanyModal()}
                    className='d-flex align-items-center justify-content-center cursor-pointer overlay-action-btn rounded-circle'
                    style={{ height: "30px", width: "30px", }}
                  >
                    <i className="bi bi-x-lg"></i>
                  </span>
                </div>
              </div>

              <div className="row " >
                <div className="col-12 px-0">
                  <div
                    className="d-flex align-items-center justify-content-center text-black text-center font-w600 fs-3"
                  >
                    {`Join company`}
                  </div>
                </div>
              </div>

              <div className="row mx-0">
                <div className="col-12 align-content-center d-flex fs-5 justify-content-center mt-3 px-0">
                  <span className="text-center">{`Join an existing company`}</span>
                </div>
              </div>

              <div>
                <form onSubmit={(e) => handleJoinCompany(e)} >
                  <div className="row mx-0 my-3 mt-4">
                    <div className="col-12 px-0">
                      <InputField
                        labelName={`Company code`}
                        placeholderName={"Company code"}
                        type={"text"}
                        value={joinCompanyCode}
                        onChange={handleJoinCompanyCode}
                        onBlur={() => { }}
                        errorMeesage={`Please enter valid company code`}
                        errorOccured={isJoinCompanyCodeError}
                      />
                    </div>
                  </div>

                  <div className="row mx-0">
                    <div className="col-12 px-0">
                      <PrimaryButton
                        onClick={(e) => {
                          handleJoinCompany(e);
                        }}
                        buttonName={"JOIN"}
                        type="submit"
                        loadingMessage="SUBMITTING..."
                        isLoading={joinCompanyLoading}
                        style={{
                          width: '100%',
                          background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                          border: '2px solid rgba(255, 154, 32, 1)',
                          boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',

                          // border: 'none',
                          // background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                          // boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                        }}
                      />
                    </div>
                  </div>

                </form>
              </div>


              {!companyId && permissionArray.includes("REGISTER COMPANY") &&
                <div>
                  <div className="separator-custom mt-4 mb-2">
                    <div
                      className="line-custom me-3"></div>
                    <span className="text-custom fs-6">{`OR`}</span>
                    <div className="line-custom ms-3"></div>
                  </div>

                  <div className="row mx-0 mb-3">
                    <div className="col-12 align-content-center d-flex fs-5 justify-content-center px-0">
                      <span className="text-center">{`You want to register new company`}</span>
                    </div>
                  </div>

                  <div className="row mx-0">
                    <div className="col-12 px-0">
                      <PrimaryButton
                        onClick={(e) => {
                          handleOpenRegisterComp()
                        }}
                        buttonName={"REGISTER COMPANY"}
                        type="submit"
                        loadingMessage="SUBMITTING..."
                        isLoading={false}
                        style={{
                          width: '100%',
                          background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                          border: '2px solid rgba(255, 154, 32, 1)',
                          boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                        }}
                      />
                    </div>
                  </div>
                </div>
              }


            </div>
          </div>
        </Modal.Body>
      </Modal>



      {/* Modal for the  verify phone or email */}
      <Modal className="fade" show={triggerForVerifyModal} centered>


        <Modal.Body>
          <div className='row mx-0'>
            <div className='col-12 px-0'>
              <>
                <div className='mx-0 row'>
                  <div className='col-12 d-flex fs-4 justify-content-end px-0 text-black'>
                    <span onClick={() => handleCloseVerifyModal()} className='cursor-pointer'>
                      <i className="bi bi-x-lg"></i>
                    </span>
                  </div>
                </div>

                <div className='mx-0 row mb-4'>
                  <div className='col-12 font-w600 fs-3 px-0 text-center text-black '>
                    <span>
                      {checkForEmailVerification && <>{"Update email"}</>}
                      {checkForPhoneVerification && <>{"Update mobile number"}</>}
                    </span>
                  </div>
                </div>

                <div className='mx-0 row mb-2'>
                  <div className='col-12 font-w500 fs-5 px-0 text-center  '>
                    {checkForEmailVerification && (
                      <span>
                        {!checkAfterVerificationCodeSend ? (
                          <>
                            {
                              "Enter a new email and we will send an OTP for verification"
                            }
                          </>
                        ) : (
                          <span className="d-flex flex-column">
                            <span>{`Enter verification code we sent to`}</span>
                            <span className="font-w600 text-black">{emailNew}</span>
                          </span>
                        )}
                      </span>
                    )}
                    {checkForPhoneVerification && (
                      <span>
                        {!checkAfterVerificationCodeSend ? (
                          <>
                            {
                              "Enter new mobile number and we will send an OTP for verification"
                            }
                          </>
                        ) : (
                          <span className="d-flex flex-column">
                            <span>{`Enter verification code we sent to your mobile number`}</span>
                            <span className="font-w600 text-black">{phoneNumberNew}</span>
                          </span>
                        )}
                      </span>
                    )}
                  </div>
                </div>

                <form onSubmit={(e) => handleVerify(e)}>
                  <div className='mx-0 row '>
                    <div className='col-12 px-0 '>
                      {checkForEmailVerification &&
                        !checkAfterVerificationCodeSend && (
                          <InputField
                            labelName={lblEmail}
                            placeholderName={"Email"}
                            type={"email"}
                            value={emailNew}
                            onChange={handleEmailNew}
                            onBlur={handleEmailBlurCheckNew}
                            errorMeesage={errorEmailMsg}
                            errorOccured={isEmailErrorNew}
                            isRequired={true}
                          />
                        )}

                      {checkForPhoneVerification &&
                        !checkAfterVerificationCodeSend && (
                          <>
                            {/* <PhonenumberField
                              inputValue={phoneNumberNew}
                              handleInputValue={handlePhonenumberNew}
                              errorOccured={isPhoneErrorNew}
                              errorMeesage={validMobileNumberText}
                              handleChangeCode={handleCountryCodeNew}
                              handleOnBlur={handlePhonenumberBlurCheckNew}
                            /> */}

                            <EmailPhoneCombine
                              inputValue={phoneNumberNew}
                              handleInputValue={handlePhonenumberNew}
                              errorOccured={isPhoneErrorNew}
                              errorMessage={validMobileNumberText}
                              handleChangeCode={handleCountryCodeNew}
                              handleOnBlur={handlePhonenumberBlurCheckNew}
                              isEnteringNumber={true}
                              defaultCodeValue={countryCodeNewNew}
                              label={txtMobileNumber}
                              isRequired={true}
                            />
                          </>
                        )}
                    </div>
                  </div>

                  <div className='mx-0 row mt-3'>
                    <div className='col-12 px-0 '>
                      {!checkAfterVerificationCodeSend && (
                        <PrimaryButton
                          onClick={handleVerify}
                          buttonName={btnVerify}
                          type={"submit"}
                          loadingMessage={"Loading..."}
                          isLoading={verifyUserLoading}
                          style={{
                            width: '100%',
                            background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                            border: '2px solid rgba(255, 154, 32, 1)',
                            boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                          }}
                        />
                      )}
                    </div>
                  </div>
                </form>

                {checkAfterVerificationCodeSend && (
                  <form onSubmit={(e) => hanldeActivateUser(e)}>
                    <div className='mx-0 row '>
                      <div className='col-12 px-0 '>
                        <InputField
                          labelName={"Code"}
                          onChange={handleValidateCode}
                          value={recievedCodeValue}
                          onBlur={handleCodeBlurCheck}
                          errorOccured={isCodeError}
                          errorMeesage={"enter valid security code"}
                          isRequired={true}
                        />
                      </div>
                    </div>

                    <div className='mx-0 row '>
                      <div className='col-12 px-0 '>
                        <div className="mx-0 row">
                          <div
                            className={`col-5 px-0 pe-3`}
                            style={{
                              pointerEvents: resendCodeCheck ? "none" : "auto",
                              opacity: resendCodeCheck ? "0.5" : "1",
                            }}
                          >
                            <SkipButton
                              buttonName={"Resend code"}
                              onClick={handleVerify}
                              style={{ width: "100%", }}
                            />
                          </div>

                          <div className="col-7 px-0">
                            <span>
                              {`Didn't receive the code? Be sure to check inbox and spam folders. Also, You can request a new code ${resendCodeTimer != 0 ? "to be sent" : ""} `}
                              {resendCodeTimer != 0 && <span className="font-w600 text-black">{`in 00:${resendCodeTimer > 9 ? resendCodeTimer : "0" + resendCodeTimer}`}</span>}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className='mx-0 row mt-3'>
                      <div className='col-12 px-0 '>

                        <PrimaryButton
                          onClick={hanldeActivateUser}
                          buttonName={"Confirm verification code"}
                          type={"submit"}
                          loadingMessage={"Loading..."}
                          isLoading={verifyUserLoading}
                          style={{
                            width: '100%',
                            background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                            border: '2px solid rgba(255, 154, 32, 1)',
                            boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                          }}
                        />

                      </div>
                    </div>

                  </form>
                )}

              </>
            </div>
          </div>


        </Modal.Body>
      </Modal>

      {/* <!-- Modal --> */}
      <Modal className="fade" show={basicModalDeleteAccount} style={{}}>
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ padding: "30px", flexDirection: "column" }}>
          <div
            style={{
              fontSize: "24px",
              fontWeight: "600",
              textAlign: "center",
              padding: "20px",
            }}>
            Are you sure you want to delete your account ?
          </div>

          <div>
            <WhiteGreenButton
              buttonName={"No"}
              onClick={() => setBasicModalDeleteAccount(false)}
              variant={"primary"}
              className={"white-background-btn"}
            />

            <WhiteGreenButton
              buttonName={"Yes"}
              onClick={deleteAccount}
              className={"green-background-btn"}
              variant={"primary"}
            />
          </div>
        </div>
      </Modal>

      {
        handleToaster && (
          <ResponceToaster toasterType={toasterType} message={responceMsg} />
        )
      }
      {/* {apiResponse && <ResponceForAPI show={apiResponse} />} */}

      <AcceptRejectModal
        text={"Are you sure you want to switch role ?"}
        modalStatus={changeRoleModal}
        onClickAccept={changeRoleAccepted}
        onClickReject={() => setChangeRoleModal(false)}
      />

      {showChangePassword && <ChangePassword
        changePasswordTrigger={showChangePassword}
        handleCloseChangePassword={handleCloseChangePassword}
      />}

      {companyModal &&
        <UserAddOwnCompany
          companyModalStatus={companyModal}
          setCompanyModalStatus={setCompanyModal}
          handleClose={() => { handleCloseCompanyModal() }}
          modalType={companyModalType}
          companyID={companyId}
          firstNameOwner={firstName}
          lastNameOwner={lastName}
          emailOwner={email}
          phoneNumberOwner={phonenumber}
          countryCodeOwner={countryCode}
        />}

      {sendProCodeModalTrigger && (
        <SendProCodeInviteLink
          sendProCodeModalTrigger={sendProCodeModalTrigger}
          handleCloseSendProCodeModal={handleCloseSendProCodeModal}
          proCode={proCodeDetails?.promo_code_str}
        />
      )}

    </>
  );
};

export default Bio;
